import React from 'react';
import PropTypes from 'prop-types';

import Switch from '@mui/material/Switch';
import { useUpdateVideoCompilationPage } from '../../../hooks/react-query/useVideoCompilationData';
import { mapCompilationFormData } from '../../../helpers/compilationHelper';

const VideoCompilationPageSwitch = ({ enabled, data, disabled }) => {
  const { mutate: updateVideoCompilationPage } = useUpdateVideoCompilationPage();

  const handleToggle = (e) => {
    e.stopPropagation();
    const payload = mapCompilationFormData(data);
    payload.enabled = !enabled;

    updateVideoCompilationPage({ data: payload, id: data?.id });
  };

  return <Switch checked={enabled} onClick={handleToggle} disabled={disabled} />;
};

VideoCompilationPageSwitch.propTypes = {
  enabled: PropTypes.bool,
  data: PropTypes.object,
  disabled: PropTypes.bool
};

export default VideoCompilationPageSwitch;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VideoCompilationPageSwitch.jsx